<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import vad from "./lib/voice-activity-detection";

  const STATUS = {
    ENTRANCE: 0,
    MEETING: 1
  };

  let status = STATUS.ENTRANCE;

  let vadObject = null;

  let channels = 0;
  let length = 0;
  let sampleRate = 0;
  let floatData = null;
  let audioContext = null;

  const initMicrophone = stream => {
    audioContext = new(window.AudioContext || window.webkitAudioContext);
    let vadOptions = {
      onVoiceStop: () => {
        stopInputMicrophone();
      },
      onUpdate: (val, inputBuffer) => {
        if (!channels) {
          channels = inputBuffer.numberOfChannels;
          floatData = new Array(channels).fill([]);
          sampleRate = inputBuffer.sampleRate;
        }
        if (hasChannelData(inputBuffer.getChannelData(0))) {
          length += inputBuffer.length;
          [...Array(channels)].map((_, i) => {
            Array.prototype.push.apply(
              floatData[i],
              inputBuffer.getChannelData(i)
            );
          });
        }
      }
    };
    // streamオブジェクトの音声検出を開始
    vadObject = vad(audioContext, stream, vadOptions);
  };

  /**
   * 音声データが存在するかどうか
   */
  const hasChannelData = array => {
    if (!array) {
      return false;
    }
    const result = array.some(value => value !== 0.0);
    return result;
  };

  const stopInputMicrophone = () => {
    if (!audioContext || !channels) {
      return;
    }
    const audioBuffer = audioContext.createBuffer(channels, length, sampleRate);
    for (let i = 0; i < channels; i++) {
      audioBuffer.getChannelData(i).set(floatData[i]);
    }
    channels = 0;
    length = 0;
    floatData = [];
    const source = audioContext.createBufferSource();

    source.buffer = audioBuffer;
    source.loop = false;
    source.loopStart = 0;
    source.loopEnd = audioBuffer.duration;
    source.playbackRate.value = 1.0;

    source.connect(audioContext.destination);

    source.start(0);
    source.onended = event => {
      //. イベントハンドラ削除
      source.onended = null;
      //. オーディオ終了
      source.stop(0);
    };
  };

  let video = null;

  const initCamera = stream => {
    const MAX_VIDEO_WIDTH = 800;
    const videoWidth =
      window.parent.screen.width > MAX_VIDEO_WIDTH
        ? MAX_VIDEO_WIDTH
        : window.parent.screen.width;
    video = document.getElementById("video");
    video.width = videoWidth;
    video.srcObject = stream;
    video.play();
    initCanvas();
  };

  let canvasList = null;
  const initCanvas = () => {
    const canvasDomList = document.querySelectorAll("canvas");

    canvasList = [];
    canvasDomList.forEach(canvas => {
      canvasList.push({
        dom: canvas,
        context: canvas.getContext("2d")
      });
    });

    updateCanvas();
  };

  const updateCanvas = () => {
    canvasList.forEach(canvas => {
      const clientWidth = canvas.dom.clientWidth;
      const clientHeight = canvas.dom.clientHeight;
      if (!canvas.dom.width) {
        canvas.dom.width = video.videoWidth;
        canvas.dom.height = video.videoHeight;
      }

      canvas.context.drawImage(
        video,
        0,
        0,
        video.videoWidth,
        video.videoHeight
      );

      if (canvas.dom.id === "canvas-me") {
        return;
      }
    });
    requestAnimationFrame(updateCanvas);
  };

  onMount(async () => {});

  /**
   * 会議に参加
   */
  const join = () => {
    //マイクとカメラの使用許可を求める
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then(stream => {
        initCamera(stream);
        initMicrophone(stream);
      })
      .catch(err => {
        window.alert(
          "ミーティングが開始できませんでした。カメラとマイクが使用可能な状態である事を確認してください。"
        );
      });
  };

  const leave = () => {
    if (confirm("通話を終了します。よろしいですか？")) {
      const tracks = document.getElementById("video").srcObject.getTracks();
      tracks.forEach(track => {
        track.stop();
      });

      document.getElementById("video").srcObject = null;

      vadObject.disconnect();
      status = STATUS.ENTRANCE;
    }
  };
</script>

<style>
  p {
    font-size:0.9em;
  }
  main {
    height: 100%;
  }

  #video {
    display: none;
  }

  .cameraCanvas {
    transform: scale(-1, 1);
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .me {
    box-shadow: 5px -5px 10px 5px rgba(0, 0, 0, 0.6);
    width:25%;
    max-width:140px;
    height: auto;
    position: fixed;
    bottom: 10px;
    right: 10px;
  }

  @media screen and (max-width: 480px) { 
    .me {
      width:15%;
      max-width:60px;
    }
  }

  .partner-block {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
  }
  .partner {
    width: 50%;
    height: 50%;
    box-sizing: border-box;
    padding: 10px;
  }

  .entrance-block {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-image: url("/3337171_m.jpg");
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .entrance {
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px;
    border-radius: 10px;

    width: 413px;
    height: 480px;
    max-width: 90%;
    max-height: 90%;

    box-sizing: border-box;
    text-align: center;

    display: flex;
    flex-direction: column;
    z-index: 1;
  }

  .entrance-block::before {
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: " ";
  }

  .space {
    flex-grow: 1;
  }

  .btn {
    border-radius: 8px;
    border: none;
    padding: 10px 40px;
    margin: 0 auto;
    color: white;
  }

  .join {
    background-color: rgb(62, 171, 215);
  }
  .join:hover {
    background-color: rgb(102, 201, 255);
  }
  .join:active {
    background-color: rgb(32, 121, 165);
  }

  .leave {
    background-color: rgb(255, 40, 40);
  }
  .leave:hover {
    background-color: rgb(255, 100, 100);
  }
  .leave:active {
    background-color: rgb(80, 0, 0);
  }

  .controller {
    position: fixed;
    bottom: 5vh;
    width: 100%;
    text-align: center;
  }
</style>

<main>
  {#if status === STATUS.MEETING}
    <video id="video" autoplay playsinline />
    <div
      class="partner-block"
      on:introend={join}
      transition:fade={{ duration: 200 }}>
      <div class="partner">
        <canvas class="cameraCanvas" width="0" height="0" />
      </div>
      <div class="partner">
        <canvas class="cameraCanvas" width="0" height="0" />
      </div>
      <div class="partner">
        <canvas class="cameraCanvas" width="0" height="0" />
      </div>
      <div class="partner">
        <canvas class="cameraCanvas" width="0" height="0" />
      </div>
    </div>
    {#if video !== null}
    <div class="controller">
      <button class="btn leave" on:click={leave}>離脱</button>
    </div>
    {/if}
    <canvas id="canvas-me" class="cameraCanvas me" width="0" height="0" />
  {/if}
  {#if status === STATUS.ENTRANCE}
    <div class="entrance-block" transition:fade={{ duration: 200 }}>
      <div class="entrance">
        <h1>単独会議</h1>
        <p>
          自分だけでWeb会議ができるアプリです。画面の向こう側にいる自分に話しかけると同じ発言が返ってきます。
        </p>
        <p>
          参加ボタンを押した際、このアプリからマイクとカメラへのアクセスを許可してください。
          <br />
          <b>
            (※音声や映像データが外部に送信される事はありません。会議の参加者はあなた独りなので。)
          </b>
        </p>
        <button class="btn join" on:click={() => (status = STATUS.MEETING)}>
          参加
        </button>
        <div class="space" />
        <footer class="copyright">
          © 2020
          <a href="https://twitter.com/de_teiu_tkg" target="_blank">
            @de_teiu_tkg
          </a>
        </footer>
      </div>
    </div>
  {/if}
</main>
